export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.23-1016.27",
  commitId: "01aff85d2caceca76c48bfdb8f7e2561e8076da3",
  commitTime: "2026-06-23T10:16:27.000Z",
});
